module.exports = __webpack_public_path__ + "static/media/crwn.5c51f3fb.png";